import React from "react";
import { esWODoble, ladoWO, marcadorDePartido } from "components/torneos/resultado";

// Fila de partido en modo SOLO LECTURA. Muestra hora, equipos, marcador y
// goleadores (si el partido está jugado). No permite editar nada.
// `resultado` ("gano" | "empato" | "perdio") es opcional: si viene, el pill del
// marcador se pinta según cómo le fue al equipo (se usa en el modal por equipo).
export default function PublicMatchCard({ match, teams, resultado }) {
  const teamName = (teamId) => {
    const t = teams.find((x) => x.id === teamId);
    return t ? t.name : "—";
  };
  const playerName = (teamId, playerId) => {
    const t = teams.find((x) => x.id === teamId);
    const p = t && t.players.find((pl) => pl.id === playerId);
    if (!p) return "";
    return (p.camiseta ? "#" + p.camiseta + " " : "") + (p.name || "Sin nombre");
  };

  const bothTeams = match.homeTeamId && match.awayTeamId;
  const marcador = marcadorDePartido(match);
  const ladoDelWO = ladoWO(match);
  const woDoble = esWODoble(match);

  const scorers = (side) => {
    const teamId = side === "home" ? match.homeTeamId : match.awayTeamId;
    const goals = side === "home" ? match.homeGoals : match.awayGoals;
    return (goals || [])
      .filter((g) => g.playerId)
      .map((g, i) => {
        const nombre = playerName(teamId, g.playerId);
        if (!nombre) return null;
        return (
          <span key={g.id || i} className="tpub-scorer">
            {nombre}
            {g.minute !== "" && g.minute != null ? " " + g.minute + "'" : ""}
          </span>
        );
      })
      .filter(Boolean);
  };

  return (
    <div className="tpub-match">
      <div className="tpub-match-line">
        <span className="tpub-match-team tpub-match-team--home">{teamName(match.homeTeamId)}</span>
        {bothTeams && match.jugado ? (
          <span className={"tpub-match-score" + (resultado ? " tpub-match-score--" + resultado : "")}>
            {woDoble ? (
              "DWO"
            ) : (
              <React.Fragment>
                {marcador.local} <span className="tpub-match-dash">-</span> {marcador.visitante}
              </React.Fragment>
            )}
          </span>
        ) : (
          <span className="tpub-match-vs">{match.hora ? match.hora : "vs"}</span>
        )}
        <span className="tpub-match-team tpub-match-team--away">{teamName(match.awayTeamId)}</span>
      </div>

      {bothTeams && match.jugado && (scorers("home").length > 0 || scorers("away").length > 0) && (
        <div className="tpub-scorers">
          <div className="tpub-scorers-col tpub-scorers-col--home">{scorers("home")}</div>
          <div className="tpub-scorers-col tpub-scorers-col--away">{scorers("away")}</div>
        </div>
      )}

      {bothTeams && match.jugado && ladoDelWO && (
        <div className="tpub-match-cancha">
          {woDoble
            ? "DWO: no se presentó ninguno de los dos"
            : "WO de " + teamName(ladoDelWO === "home" ? match.homeTeamId : match.awayTeamId)}
        </div>
      )}

      {bothTeams && !match.jugado && match.cancha && (
        <div className="tpub-match-cancha">Cancha {match.cancha}</div>
      )}

      {!bothTeams && <div className="tpub-match-pending">A definir</div>}
      {bothTeams && !match.jugado && (match.hora || match.cancha) && (
        <div className="tpub-match-pending">Aún no se jugó</div>
      )}
    </div>
  );
}
